<template>
  <div class="pt-20 pr-10 pl-10">
    <tabs>
      <tab name="Credenciales">
        <el-row :gutter="20">
          <el-col :span="8" :offset="8">
            <div class="max-w-sm rounded overflow-hidden shadow-lg bg-white">
              <div class="px-6 py-4">
                <div class="text-gray-800 font-bold text-xl mb-2">
                  Access token
                </div>
                <p class="text-gray-700 text-base">
                  Token para poder consultar a las apis
                </p>
              </div>
              <div class="px-6 py-4">
                <span
                  class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2"
                  >{{ tokenValue }}</span
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </tab>
      <tab name="Reporte peticiones">
        <!--<el-row :gutter="20" class="pb-10">
          <el-col :span="4" :offset="10">
            <el-select
              v-model="monthSelected"
              placeholder="Select"
              @change="changeMonth()"
            >
              <el-option
                v-for="item in monthsOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>-->

        <el-row :gutter="20">
          <el-col :span="8" :offset="8">
            <h2>Peticiones por dia:</h2>

            <canvas id="planet-chart" width="100"></canvas>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <h2>Peticiones actuales</h2>
            <el-divider></el-divider>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="serviceName" label="Service" width="180">
              </el-table-column>
              <el-table-column prop="monthName" label="Mes actual" width="180">
              </el-table-column>
              <el-table-column prop="totalRequest" label="Cantidad" width="180">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </tab>
      <tab name="Permisos DNS">
        <el-row :gutter="20">
          <h1>Geocoding</h1>
          <el-divider></el-divider>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <h2>Permitir dominios:</h2>
          </el-col>
          <el-col :span="4">
            <el-switch v-model="dataUserGeocodingDns.enableDnsRequests">
            </el-switch>
          </el-col>
          <el-col :span="4">
            <h2>Dns permitidos</h2>
          </el-col>
          <el-col :span="8">
            <el-input
              placeholder="Please input"
              :disabled="!dataUserGeocodingDns.enableDnsRequests"
              v-model="dataUserGeocodingDns.dnsAllowed"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" round @click="changeDnsRouting()"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="20" class="pt-3">
          <h1>Routing</h1>
          <el-divider></el-divider>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <h2>Permitir dominios:</h2>
          </el-col>
          <el-col :span="4">
            <el-switch v-model="dataUserRoutingDns.enableDnsRequests">
            </el-switch>
          </el-col>
          <el-col :span="4">
            <h2>Dns permitidos</h2>
          </el-col>
          <el-col :span="8">
            <el-input
              placeholder="Please input"
              :disabled="!dataUserRoutingDns.enableDnsRequests"
              v-model="dataUserRoutingDns.dnsAllowed"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" round @click="changeDnsRouting()"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </tab>
    </tabs>
  </div>
</template>
<script>
import Chart from "chart.js";

import axios from "axios";

export default {
  components: {},
  data() {
    return {
      tokenValue: "",
      dataDaysrequest: null,
      arraydataDaysrequest: [],
      arrayDaysrequest: [],
      tableData: [],

      urlGetMonth: "",

      month: "",
      year: "",
      monthsOption: [
        {
          value: "actual",
          label: "Mes actual",
        },
        {
          value: "last",
          label: "Mes anterior",
        },
      ],
      monthSelected: "actual",
      monthForRequest: "",
      optionSelected: "day",
      optionForRequest: "",

      dataUserGeocodingDns: "",
      dataUserPlacesDns: "",
      dataUserRoutingDns: "",
    };
  },
  created() {
    console.log("obtener token");
    let token = JSON.parse(window.localStorage.getItem("geodir_Token"));
    //_geo.setAccessToken(token.data.access_token);
    //app.access_token= token.data.access_token;
    console.log(token);
    this.tokenValue = token.data.access_token;

    // Obtener las peticiones actuales
    var d = new Date();
    var numberMonth = d.getMonth();
    var year = d.getFullYear();
    console.log("obtener data del mes");
    //Obtiene el numero del mes empezando en cero
    this.getDataMonth(year, numberMonth + 1);

    // MOSTRAR GRAFICO
    this.evaluateValueForMonth();

    // Obtenber grafico de prueba
    //this.getDataForGraphs();

    console.warn("EJECUTAR PETICIONES");

    // asignar el valor del año

    this.year = year;
    this.executeServicesRequestPerDay();

    this.getDataDnsServices();
  },
  mounted() {
    console.log("crear chart");

    //this.createChart("planet-chart", this.planetChartData);
    //this.renderChart(this.chartData, this.options);
  },
  methods: {
    changeDnsGeocoding() {
      let urlsasads = process.env.VUE_APP_GEOCODING_USER_DNS + "dns-changes";
      let self = this;
      axios
        .get(urlsasads, {
          params: {
            key: this.tokenValue,
            dns_names: this.dataUserGeocodingDns.dnsAllowed,
            dns_enabled: this.dataUserGeocodingDns.enableDnsRequests,
          },
        })
        .then((response) => {
          console.log(response);
          self.dataUserGeocodingDns = response.data;
        });
    },

    changeDnsRouting() {
      let urlsasads = process.env.VUE_APP_ROUTING_USER_DNS + "dns-changes";
      let self = this;
      axios
        .get(urlsasads, {
          params: {
            key: this.tokenValue,
            dns_names: this.dataUserRoutingDns.dnsAllowed,
            dns_enabled: this.dataUserRoutingDns.enableDnsRequests,
          },
        })
        .then((response) => {
          console.log(response);
          self.dataUserRoutingDns = response.data;
        });
    },

    getDataDnsServices() {
      this.getDataRoutingUser();
    },

    getDataGeocodinggUser() {
      let urlGeocodingGetUSrDns =
        process.env.VUE_APP_GEOCODING_USER_DNS + "dns";

      let self = this;
      axios
        .get(urlGeocodingGetUSrDns, {
          params: {
            key: this.tokenValue,
          },
        })
        .then((response) => {
          console.log(response);
          self.dataUserGeocodingDns = response.data;
        });
    },
    getDataRoutingUser() {
      let urlRoutingGetUSrDns = process.env.VUE_APP_ROUTING_USER_DNS + "dns";

      let self = this;
      axios
        .get(urlRoutingGetUSrDns, {
          params: {
            key: this.tokenValue,
          },
        })
        .then((response) => {
          console.log(response);
          self.dataUserRoutingDns = response.data;
        });
    },

    getDataMonth(year, monthValue) {
      this.getDataMonthGeocoding(year, monthValue);
      this.getDataMonthPlaces(year, monthValue);
      this.getDataMonthRouting(monthValue);
    },

    getDataMonthGeocoding(year, monthValue) {
      let self = this;
      let urlGeocodingGetMonth =
        process.env.VUE_APP_GEOCODING_REQUESTS + "/months";
      axios
        .get(urlGeocodingGetMonth, {
          params: {
            key: this.tokenValue,
            month: monthValue,
          },
        })
        .then((response) => {
          console.log(response);
          let serviceRequest = self.addServiceMonth(response.data, "Geocoding");
          self.tableData.push(serviceRequest);
        });
    },

    getDataMonthPlaces(year, monthValue) {
      let self = this;
      let urlPlacesGetMonth = process.env.VUE_APP_PLACES_REQUESTS + "/months";
      axios
        .get(urlPlacesGetMonth, {
          params: {
            key: this.tokenValue,
            month: monthValue,
          },
        })
        .then((response) => {
          console.log(response);
          let serviceRequest = self.addServiceMonth(response.data, "Places");
          self.tableData.push(serviceRequest);
        });
    },

    getDataMonthRouting(monthValue) {
      let self = this;
      let urlroutingGetMonth = process.env.VUE_APP_ROUTING_REQUESTS + "/months";
      axios
        .get(urlroutingGetMonth, {
          params: {
            key: this.tokenValue,
            month: monthValue,
          },
        })
        .then((response) => {
          console.log(response);
          let serviceRequest = self.addServiceMonth(response.data, "Routing");
          self.tableData.push(serviceRequest);
        });
    },

    addServiceMonth(requestPerMonth, serviceName) {
      var serviceRequest = {
        totalRequest: requestPerMonth.totalRequest,
        monthName: requestPerMonth.monthName,
        serviceName: serviceName,
      };
      return serviceRequest;
    },

    getDataForGraphs() {
      if (this.optionSelected == "day") {
        this.getRequestsDays();
      } else if (this.optionSelected == "month") {
        this.getRequestsDaysTotal();
      }
    },

    getRequestsDays() {
      let self = this;

      // GEOCODING
      let urlGetDaysRequest = process.env.VUE_APP_GEOCODING_REQUESTS + "/days";
      axios
        .get(urlGetDaysRequest, {
          params: {
            key: this.tokenValue,
            month: this.monthForRequest,
          },
        })
        .then((response) => {
          console.log(response);
          self.getDataOfRequests(response.data);
        });
    },

    getDataOfRequests(dataDaysrequest) {
      for (const dayarequest in dataDaysrequest) {
        console.log(dataDaysrequest[dayarequest].totalRequest);
        this.arraydataDaysrequest.push(
          dataDaysrequest[dayarequest].totalRequest
        );
      }
      console.log("peticiones cantidad");
      console.log(this.arraydataDaysrequest);

      for (const dayarequest in dataDaysrequest) {
        console.log(dataDaysrequest[dayarequest].dayRequests);
        this.arrayDaysrequest.push(dataDaysrequest[dayarequest].dayRequests);
      }

      console.log("peticiones cantidad");
      console.log(this.arrayDaysrequest);

      this.createChart(
        "planet-chart",
        this.arraydataDaysrequest,
        this.arrayDaysrequest
      );
    },

    /*changeMonth() {
      this.evaluateValueForMonth();
      console.warn("SE SELECCION EL VALOR DEL MES");
      console.log(this.monthForRequest);
      this.executeServicesRequestPerDay();
    },*/

    changeOptionDayMonth() {
      if (this.optionSelected == "day") {
        this.getRequestsDays();
      } else if (this.optionSelected == "month") {
        this.getRequestsDaysTotal();
      }
    },

    evaluateValueForMonth() {
      var d = new Date();
      if (this.monthSelected == "actual") {
        this.monthForRequest = d.getMonth() + 1;
      } else if (this.monthSelected == "last") {
        this.monthForRequest = d.getMonth();
      }
    },
    async executeServicesRequestPerDay() {
      console.log("services for create chart");
      let arrayDatasets = [];
      let resultGeocoding = await this.getGeocodingRequestPerDay();
      let datasetGeocoding = this.createDatasetForGraphic(
        resultGeocoding,
        "Geocoding",
        "rgba(0, 152, 33,0.8)"
      );
      arrayDatasets.push(datasetGeocoding);

      let resultPlaces = await this.getPlacesRequestPerDay();
      let datasetPlaces = this.createDatasetForGraphic(
        resultPlaces,
        "Places",
        "rgba(74, 112, 255,0.8)"
      );
      arrayDatasets.push(datasetPlaces);

      /*let resultRouting = await this.getRoutingRequestPerDay();
      let datasetRouting = this.createDatasetForGraphic(
        resultRouting,
        "Routing",
        "rgba(230, 0, 0,0.6)"
      );
      arrayDatasets.push(datasetRouting);*/

      this.createChartRequests("planet-chart", arrayDatasets);
    },

    getArrayValues(dataRequestResult) {
      // Llenar valor de labels
      if (this.arrayDaysrequest.length == 0) {
        console.log("Obtener labels para dataset");
        for (const dayarequest in dataRequestResult) {
          this.arrayDaysrequest.push(
            dataRequestResult[dayarequest].dayRequests
          );
        }
        console.log(this.arrayDaysrequest);
      }

      console.log("Obtener valores para dataset");
      let arrayValues = [];
      for (const dayarequest in dataRequestResult) {
        arrayValues.push(dataRequestResult[dayarequest].totalRequest);
      }
      console.log(arrayValues);
      return arrayValues;
    },

    createDatasetForGraphic(dataResult, label, colorRGB) {
      console.log("Crear dataset para graficos");
      let arrayNumberRequest = this.getArrayValues(dataResult);
      var dataset = {
        label: label,
        backgroundColor: colorRGB,
        data: arrayNumberRequest,
        stack: 1,
      };
      console.log(dataset);
      return dataset;
    },

    async getGeocodingRequestPerDay() {
      console.log("Inicio geocoding per day");
      let urlGetDaysRequest = process.env.VUE_APP_GEOCODING_REQUESTS + "/days";
      let response = await axios.get(urlGetDaysRequest, {
        params: {
          key: this.tokenValue,
          month: this.monthForRequest,
          year: this.year,
        },
      });
      return await response.data;
    },

    async getPlacesRequestPerDay() {
      console.log("Inicio places per day");
      let urlGetDaysRequest = process.env.VUE_APP_PLACES_REQUESTS + "/days";
      let response = await axios.get(urlGetDaysRequest, {
        params: {
          key: this.tokenValue,
          month: this.monthForRequest,
          year: this.year,
        },
      });
      return await response.data;
    },

    async getRoutingRequestPerDay() {
      console.log("Inicio routing per day");
      let urlGetDaysRequest = process.env.VUE_APP_ROUTING_REQUESTS + "/days";
      let response = await axios.get(urlGetDaysRequest, {
        params: {
          key: this.tokenValue,
          month: this.monthForRequest,
        },
      });
      return await response.data;
    },

    createChartRequests(chartId, arrayDatasets) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.arrayDaysrequest,
          datasets: arrayDatasets,
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      });
    },

    createChart(chartId, arrayNumberRequest, arrayDaysrequest) {
      const ctx = document.getElementById(chartId);
      console.log(arrayNumberRequest);
      console.log(arrayDaysrequest);

      var dataRequestsGeocoding = {
        label: "requests Geocoding",
        backgroundColor: "rgba(99,255,132,0.6)",
        data: arrayNumberRequest,
        stack: 1,
      };
      var dataRequestsPlaces = {
        label: "requests per day",
        backgroundColor: "rgba(99,132,255,0.6)",
        data: [452, 130, 0],
        stack: 1,
      };

      new Chart(ctx, {
        type: "bar",
        data: {
          labels: arrayDaysrequest,
          datasets: [dataRequestsGeocoding, dataRequestsPlaces],
        },
        options: {
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      });
    },
  },
};
</script>
<style scoped>
.tabs-component {
  margin: 4em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(2px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: 0.75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 4em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 4em 2em;
  }
}
</style>